import BadgeKeys from './BadgeKeys';

export default BadgeKeys;
